import moment from "moment-timezone";

const ISO_DATE_REGEX = /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})([-+]\d{2}:\d{2})/;
const TIME_ONLY_24H_FORMAT = "HH:mm";
const DATE_ONLY_FORMAT = "YYYY-MM-DD";

const convertDateToSpecificFormat = (value, format) =>
  moment(value).format(format);

export const dateToOnlyTimeString = dateValue =>
  convertDateToSpecificFormat(dateValue, TIME_ONLY_24H_FORMAT);
export const dateToOnlyDateString = dateValue =>
  convertDateToSpecificFormat(dateValue, DATE_ONLY_FORMAT);

export const convertToLocal = (value, timeZone) => {
  const momentDate = moment.tz(value, timeZone);
  const dateFormat = "YYYY-MM-DDTHH:mm:ss";
  const formattedDate = momentDate.format(dateFormat);

  return value && new Date(formattedDate);
};

export const convertToUtc = (value, timeZone) => {
  const dateString = moment(value).format();

  if (ISO_DATE_REGEX.test(dateString)) {
    const matches = dateString.match(ISO_DATE_REGEX);

    return moment
      .tz(!timeZone ? dateString : matches[1], timeZone)
      .utc()
      .format();
  }

  return dateString;
};

export const convertDateAndTimeToDate = (onlyDate, onlyTime) => {
  const formattedDateTime = `${onlyDate} ${onlyTime}`; // => "YYYY-MM-DDTHH:mm"

  return moment(formattedDateTime).toDate();
};

export const formatDateAndTimeToUTCString = (
  onlyDate,
  onlyTime,
  timeZone = ""
) => {
  const formattedDateTime = `${onlyDate} ${onlyTime}`; // => "YYYY-MM-DDTHH:mm:ssZ"

  return convertToUtc(formattedDateTime, timeZone);
};

export const getAdjustedMinDate = (dateTime, delay, params) => {
  const isAdjustForTimeZone = params.includes("TDFieldOptionAdjustForTimezone");
  const minDate = new Date(
    Date.now() + (isAdjustForTimeZone ? 0 : delay ? delay * 1000 : 259200000)
  );
  const adjastedMinDate = dateTime
    ? !moment(dateTime).add(72, "hours").isAfter(minDate)
      ? moment(minDate).add(1, "day").toDate()
      : minDate
    : minDate;

  return adjastedMinDate;
};

export const getLocalTimeZone = () =>
  new Intl.DateTimeFormat().resolvedOptions().time_zone;
